var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPubmedsearchSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.741,
    height: 32.741,
    viewBox: "0 0 32.741 32.741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1113",
    d: "M0-682.665H32.741v32.741H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "book",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1107",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1109",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1111",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1117",
    transform: "translate(0.48 8.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1119",
    d: "M-36.177,0H-38V23.021h14.932",
    transform: "translate(38)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1121",
    transform: "translate(17.33 31.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1123",
    d: "M-61.988,0h-3.123",
    transform: "translate(65.111 0)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1125",
    transform: "translate(22.51 8.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1127",
    d: "M-157.4,0h1.823V23.021h-9.752",
    transform: "translate(165.333)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1129",
    transform: "translate(15.411 29.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1131",
    d: "M-38.081,0V2.046a.96.96,0,0,1-.959.959A.96.96,0,0,1-40,2.046V0Z",
    transform: "translate(40)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1133",
    transform: "translate(19.248 17.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1135",
    d: "M0,0H1.237",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1137",
    transform: "translate(24.79 19.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1139",
    d: "M-55.015,0h-2.772",
    transform: "translate(57.787)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1141",
    transform: "translate(19.248 19.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1143",
    d: "M-77.661,0h-3.912",
    transform: "translate(81.573)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1145",
    transform: "translate(19.248 22.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1147",
    d: "M0,0H8.313",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1149",
    transform: "translate(19.248 24.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1151",
    d: "M0,0H2.948",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1153",
    transform: "translate(2.302 6.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1155",
    d: "M0-314.807v-15.859H2.785",
    transform: "translate(0 330.666)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1157",
    transform: "translate(2.302 6.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1159",
    d: "M-223.982,0h2.785V20.719h-14.069V17.937",
    transform: "translate(235.266)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1161",
    transform: "translate(16.371 6.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1163",
    d: "M-279.264-111.918v15.081h-14.069v-20.719h5.686",
    transform: "translate(293.333 117.556)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1165",
    transform: "translate(25.894 6.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1167",
    d: "M0,0H4.545V3.613",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path1169",
    d: "M62.068-110.748H48v-1.918H62.068Z",
    transform: "translate(-45.698 140.004)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1171",
    d: "M355.4-110.748H341.333v-1.918H355.4Z",
    transform: "translate(-324.962 140.004)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1173",
    transform: "translate(22.057 0.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1175",
    d: "M-69.945-327.108h-3.21a.313.313,0,0,1-.313-.313V-342.66a.927.927,0,0,1,.927-.927h1.982a.927.927,0,0,1,.927.927v15.238A.313.313,0,0,1-69.945-327.108Z",
    transform: "translate(73.469 343.587)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1177",
    transform: "translate(22.057 15.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1179",
    d: "M-69.944-38.081h-3.21a.313.313,0,0,1-.313-.313V-40h3.837v1.605A.313.313,0,0,1-69.944-38.081Z",
    transform: "translate(73.468 40)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1181",
    transform: "translate(22.057 3.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1183",
    d: "M-76.162-38.081H-80V-40h3.837Z",
    transform: "translate(79.998 40)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1185",
    transform: "translate(22.441 16.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1187",
    d: "M-25.159-73.657c-2-2.494-1.033-3.711-1.033-3.711h2.6s.97,1.217-1.033,3.711A.346.346,0,0,1-25.159-73.657Z",
    transform: "translate(26.426 77.368)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1189",
    transform: "translate(23.976 16.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1191",
    d: "M0,0V1.279",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1193",
    transform: "translate(8.377 14.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1195",
    d: "M-38.081,0V7.829a.96.96,0,0,1-.959.959A.96.96,0,0,1-40,7.829V0",
    transform: "translate(40)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1197",
    transform: "translate(4.221 4.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1199",
    d: "M-101.551-203.1a5.122,5.122,0,0,1-5.116-5.116,5.122,5.122,0,0,1,5.116-5.116,5.122,5.122,0,0,1,5.116,5.116A5.122,5.122,0,0,1-101.551-203.1Z",
    transform: "translate(106.666 213.333)",
    fill: "rgba(0,0,0,0)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPubmedsearchSmall);
export default __webpack_public_path__ + "static/media/pubmedsearch_small.6cb8d48248ff0eea5491264c6eac1e2d.svg";
export { ForwardRef as ReactComponent };